const scheduledServicesStore = {
  scheduledServiceCreated: 'Scheduled Service successfully created',
  scheduledServicesCreated: 'Scheduled Services successfully created',
  scheduledServiceDeleted: 'Scheduled Service successfully deleted',
  scheduledServiceUpdated: 'Scheduled service successfully updated',
};

export default scheduledServicesStore;
